import {useApp} from '../../../contexts/AppContext';
import {useEffect, useRef, useState} from 'react';
import {useParams, Navigate, useNavigate} from 'react-router-dom';
import styled from 'styled-components';
import config from '../../../config';
import PCImage from './pc.jpg';
import SPImage from './sp.jpg';
import {PageMainTitle} from '../../atoms/CommonParts';

const Page = styled.div`
`;

const AboutContents = styled.div`
  margin-top: 40px;
  padding-bottom: 80px;
  border-bottom: 1px solid #000000;
`;

const AboutImage = styled.img`
  border-radius: 6px;

  &.pc {
    width: 50%;
    float: right;
    margin-left: 20px;
    margin-bottom: 20px;
  }

  &.sp {
    width: 100%;
    height: auto;
    margin-bottom: 30px;
  }
`;

const AboutDescription = styled.div`
  font-size: 14px;
  font-weight: bolder;
  line-height: 26px;

  ol {
    list-style: decimal;
    padding-left: 1rem;
    margin-top: 0.5em;
    margin-bottom: 1.5em;

    li {
      margin-bottom: 0.5em;
    }
  }
`;

const SubChoicesBackButton = styled.a`
  display: block;
  margin: 60px auto 0;
  text-decoration: none;
  color: #000000;
  height: 36px;
  line-height: 35px;
  border: 1px solid #000000;
  //padding: 0 30px;
  width: 130px;
  text-align: center;
  border-radius: 18px;
  font-weight: bold;
  font-size: 14px;
  transition: background-color 0.15s linear, border-color 0.15s linear;


  @media ${config.layout.wide} {
    &:hover {
      background-color: #000000;
      color: #fff;
      border-color: #000000;
    }
  }

  &.manual_top_button {
    padding-left: 9px;
  }

  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5.875' height='10.185' viewBox='0 0 5.875 10.185'%3E%3Cpath id='パス_44' data-name='パス 44' d='M5.092,0l.783.783-4.31,4.31L5.875,9.4l-.783.783L0,5.092Z' transform='translate(0 0)' fill='%23000000'/%3E%3C/svg%3E%0A");
  background-position: 15px center;
  background-repeat: no-repeat;

  @media ${config.layout.wide} {
    &:hover {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5.875' height='10.185' viewBox='0 0 5.875 10.185'%3E%3Cpath id='パス_44' data-name='パス 44' d='M5.092,0l.783.783-4.31,4.31L5.875,9.4l-.783.783L0,5.092Z' transform='translate(0 0)' fill='%23ffffff'/%3E%3C/svg%3E%0A");
    }
  }

`;

export default function KUVOCareApplyPage() {
  const app = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    app.showHeader();
    document.title = 'KUVO Care';
  });

  return (
      <Page>
        <PageMainTitle><span>KUVO Care</span></PageMainTitle>

        <AboutContents>
          <AboutDescription>
            <AboutImage src={PCImage} className={'pc'}/>
            <AboutImage src={SPImage} className={'sp'}/>
            As a benefit of using KUVO at your venue, you've received the KUVO
            Care extended warranty service on your CDJ-3000 and
            CDJ-3000X
            unit(s). <br/>
            <br/>
            The terms and conditions of AlphaTheta's manufacturer's warranty,
            including any conditions and limitations, apply in full to the KUVO
            Care service.<br/>
            <br/>
            *Conditions:<br/>
            <ol>
              <li>Only offered to professional users using the CDJ-3000 and
                CDJ-3000X unit(s)
                in
                their venue for professional purposes.
              </li>
              <li>The venue must transmit data via KUVO prior month to the date
                of repair.
              </li>
              <li>CDJ-3000 units need to be registered in [KUVO for Venues] to
                qualify for KUVO Care.
              </li>
            </ol>
            <br/>
            To activate a KUVO Care request for repair:<br/>
            <ol>
              <li>Go to “Device” page</li>
              <li>Make sure the “serial no.” of the unit requiring repair is
                saved. You can find the serial # on your respective CDJ-3000 and
                CDJ-3000X in
                UTILITY (Hold MENU)→ Info → SERIAL No.
                Or, labeled on the bottom side of the CDJ-3000 and CDJ-3000X.
              </li>
              <li>Once the “serial no.” is registered, click “Request for
                repair”.
              </li>
              <li>Click “Apply” to be redirected to your region’s support
                page.
              </li>
              <li>Select your device and necessary details about your repair
                request.
              </li>
              <li>Indicate “KUVO Care” as a note in the “Fault Description”
              </li>
              <li>Submit form, await confirmation by your local authorized
                service center.
              </li>
              <li>Please prepare to ship your equipment.</li>
            </ol>
            <br/>

            KUVO Care is currently available in the UK, Netherlands, Denmark,
            France, and Australia.<br/>
            <br/>
            KUVO Care is offered by<br/>
            AlphaTheta EMEA Limited<br/>
            Unit 39, Tileyard Studios, Tileyard Road, London, N7 9AH<br/>
            <br/>
            Jands Pty Ltd<br/>
            ABN 45 001 187 837<br/>
            40 Kent Road<br/>
            Mascot, NSW, 2020<br/>
            Australia<br/>
          </AboutDescription>
        </AboutContents>

        <SubChoicesBackButton href={'#'} onClick={(e) => {
          e.preventDefault();
          navigate('/devices/');
        }}
        >Back</SubChoicesBackButton>
      </Page>
  );
}
